const Actions = {
  setCanvas: canvas => {
    return dispatch => {
      dispatch({
        type: "SET_CANVAS",
        payload: canvas
      });
    };
  }
};

export default Actions;



// WEBPACK FOOTER //
// ./src/actions/CanvasActions.js